import { Component } from '@angular/core';

// Angular modules
import {CommonModule} from '@angular/common';

// Angular material components
import {MatIconModule} from '@angular/material/icon';

// Custom services
import { LanguageService } from '../../../services/language/language.service';
import { UserAuthenticationService } from '../../../services/google/user-authentication.service';
import { ControllerService } from '../../../services/controller/controller.service';



@Component({
  selector: 'app-footer',
  imports: [
    // Angular modules
    CommonModule,
    // Angular material components
    MatIconModule,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {

  constructor(
    public controllerService:ControllerService,
    public userAuthenticationService:UserAuthenticationService,
    public languageService:LanguageService,
  ) { }

  button_logout(){
    this.userAuthenticationService.logout()
  }

}
